module.exports = __webpack_public_path__ + "img/vertical-logo-pink-id.0bfecfd0.svg";